var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternationalPlug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#898B91",
    d: "M18.933 4C19.523 4 20 4.478 20 5.067v13.866c0 .59-.478 1.067-1.067 1.067H5.067A1.067 1.067 0 014 18.937V5.067C4 4.477 4.478 4 5.067 4zm-4.838 2.94a5.477 5.477 0 10-4.191 10.12 5.477 5.477 0 004.191-10.12zm-3.92 2.735a.5.5 0 01.5.5v3.651a.5.5 0 01-1 0v-3.651a.5.5 0 01.5-.5zm3.65 0a.5.5 0 01.5.5v3.651a.5.5 0 11-1 0v-3.651a.5.5 0 01.5-.5z"
  })));
}
export default SvgInternationalPlug;